export const LABEL_WIDTH = 160;
export const GAP = 10;

export const rowStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: GAP,
  marginBottom: 10,
};